import escapeHtml from "../functions/dropdowns/escapeHtml";

export default class SelectedOption {

  static template(name, value, placeholder){
    return `
  <input
    type="hidden"
    name="${escapeHtml(name)}[]"
    value="${escapeHtml(value)}"
    data-views--multiselect-search-target="selected"
    data-placeholder-value="${placeholder}"
    data-untouchable-track-changed="true"
    role="option">
  `;
  }

  static addTo(controller, name, value, placeholder) {
    controller.element.insertAdjacentHTML("beforeend", SelectedOption.template(name, value, placeholder));
  }
}
